/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { Gnosis_safe__factory } from "./Gnosis_safe__factory";
